import React from "react";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Hompage from "./pages/Hompage";
import Receiptpage from "./pages/Receiptpage";
import Header from "./components/home/layout/Header";
import NewsDetailpage from "./pages/NewsDetailpage";
import ScrollToTop from "./pages/ScrollToTop";
import Inquirypage from "./pages/Inquirypage";
import Marketingpage from "./pages/Marketingpage";
import MainPage from "./pages/Mainpage";
import { NewsCardLetterViewProps } from "./pages/Mainpage";
import DigitalReceiptPage from "./pages/DigitalReceiptPage";

function App() {
  //MARK: Variable
  const navigate = useNavigate();
  // 전자영수증 페이지 이동 Action
  const goToReceiptPage = () => {
    navigate("/mpaper");
  };

  // 마케팅 페이지 이동 Action
  const goToMarketingPage = () => {
    navigate("/mkt");
  };

  // 문의하기 페이지 이동 Action
  const goToContactPage = () => {
    navigate("/contact");
  };

  // 회사소개 페이지 이동 Action
  const goToIntroducePage = () => {
    navigate("/");
  };

  const goToNewsSection = () => {
    navigate("/#main-inquiry-news-section");
  };

  const goToReceiptDigitalSection = () => {
    navigate("/mpaper#receipt-digital-section");
  };

  const mainPageEntity: NewsCardLetterViewProps[] = [
    {
      variant: "hero",
      imageUrl: "/assets/images/main_receipt_cyan.png",
      category: "전자영수증",
      index: 1,
      title: `종이 영수증의 대안, 그 이상의 가치\n 더리얼 전자영수증`,
      
      pointColor: "#083158",
      callBack: goToReceiptPage,
    },
    {
      variant: "teaser",
      category: "보도자료",
      title: "더리얼 최신 언론",
      index: 2,
      meta: "2025.08.04 ",
      callBack: goToNewsSection,
    },
    {
      variant: "normal",
      imageUrl: "/assets/images/main_receipt_introduce.png",
      category: "회사소개",
      index: 3,
      title: "국내 최초 전자영수증 플랫폼 서비스 소개",
      pointColor: "black",
      callBack: goToIntroducePage,
    },
    {
      variant: "hero",
      imageUrl: "/assets/images/main_receipt_cyan.png",
      category: "디지털 마케팅",
      title: "브랜드 가치를 높이는 디지털 마케팅",
      index: 1,
      description: "15년 실전 경험으로 검증된 마케팅 ",
      pointColor: "#b81414",
      callBack: goToMarketingPage,
    },
    {
      variant: "action",
      title: "더리얼 1:1 문의",
      description: "문의 남겨주시면 최대한 빠르게 답변드리곘습니다",
      index: 3,
      cta: "문의하기",
      callBack: goToContactPage,
    },
    {
      variant: "normal",
      index: 3,
      imageUrl: "https://placehold.co/600x800/1E1B18/FFFFFF?text=Culture",
      category: "전자영수증 이야기",
      title: "당신의 손안에서, 모든 것이 이루어집니다.",
      pointColor: "black",
      textColor: "white",
      callBack: goToReceiptDigitalSection
    },

    
  ];

  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/mpaper" element={<DigitalReceiptPage />} />
        <Route path="/" element={<MainPage entity={mainPageEntity} />} />
        <Route path="/news/:idx" element={<NewsDetailpage />} />
        <Route path="/" element={<Hompage />} />
        <Route path="/mkt" element={<Marketingpage />} />
        <Route path="/contact" element={<Inquirypage />} />
      </Routes>
    </>
  );
}

export default App;
